import React from 'react';
import {mergeAndSortExcursionAndTacEntries} from "../../utils/cartUtils";
import CartExcursionEntryConfirmation from "./CartExcursionEntryConfirmation";
import CartElementTacConfirmation from "./CartElementTacConfirmation";


function CartElementsConfirmationCombined(props) {

    const combinedSortedEntries = mergeAndSortExcursionAndTacEntries(props.paidExcursions, props.paidTacEntries, props.cruiseStartDate);


    return (
        <div className="w-full my-2 text-grey-darker">
            {combinedSortedEntries.map(entry =>
                entry.excursionId ?
                <CartExcursionEntryConfirmation key={entry.excursionId} excursion={entry} strikePrice={props.strikePrices}/> :
                <CartElementTacConfirmation key={entry.id} entry={entry} strikePrice={props.strikePrices}/>
            )}
        </div>
    );
}

export default CartElementsConfirmationCombined;